/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CreateTimerRequest,
    IdResponse,
} from '../models';

export interface ShowTimerApiControllerCreateLiveStreamTimerRequest {
    liveStreamId: string;
    createTimerRequest: CreateTimerRequest;
}

export interface ShowTimerApiControllerCreateUpcomingShowTimerRequest {
    upcomingShowId: string;
    createTimerRequest: CreateTimerRequest;
}

export interface ShowTimerApiControllerRemoveLiveStreamTimerRequest {
    liveStreamId: string;
    timerId: string;
}

export interface ShowTimerApiControllerRemoveUpcomingShowTimerRequest {
    upcomingShowId: string;
    timerId: string;
}

/**
 * 
 */
export class ShowTimerApi extends runtime.BaseAPI {

    /**
     */
    async showTimerApiControllerCreateLiveStreamTimerRaw(requestParameters: ShowTimerApiControllerCreateLiveStreamTimerRequest): Promise<runtime.ApiResponse<IdResponse>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling showTimerApiControllerCreateLiveStreamTimer.');
        }

        if (requestParameters.createTimerRequest === null || requestParameters.createTimerRequest === undefined) {
            throw new runtime.RequiredError('createTimerRequest','Required parameter requestParameters.createTimerRequest was null or undefined when calling showTimerApiControllerCreateLiveStreamTimer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}/timers`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createTimerRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async showTimerApiControllerCreateLiveStreamTimer(requestParameters: ShowTimerApiControllerCreateLiveStreamTimerRequest): Promise<IdResponse> {
        const response = await this.showTimerApiControllerCreateLiveStreamTimerRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async showTimerApiControllerCreateUpcomingShowTimerRaw(requestParameters: ShowTimerApiControllerCreateUpcomingShowTimerRequest): Promise<runtime.ApiResponse<IdResponse>> {
        if (requestParameters.upcomingShowId === null || requestParameters.upcomingShowId === undefined) {
            throw new runtime.RequiredError('upcomingShowId','Required parameter requestParameters.upcomingShowId was null or undefined when calling showTimerApiControllerCreateUpcomingShowTimer.');
        }

        if (requestParameters.createTimerRequest === null || requestParameters.createTimerRequest === undefined) {
            throw new runtime.RequiredError('createTimerRequest','Required parameter requestParameters.createTimerRequest was null or undefined when calling showTimerApiControllerCreateUpcomingShowTimer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/upcoming-shows/{upcomingShowId}/timers`.replace(`{${"upcomingShowId"}}`, encodeURIComponent(String(requestParameters.upcomingShowId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createTimerRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async showTimerApiControllerCreateUpcomingShowTimer(requestParameters: ShowTimerApiControllerCreateUpcomingShowTimerRequest): Promise<IdResponse> {
        const response = await this.showTimerApiControllerCreateUpcomingShowTimerRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async showTimerApiControllerRemoveLiveStreamTimerRaw(requestParameters: ShowTimerApiControllerRemoveLiveStreamTimerRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling showTimerApiControllerRemoveLiveStreamTimer.');
        }

        if (requestParameters.timerId === null || requestParameters.timerId === undefined) {
            throw new runtime.RequiredError('timerId','Required parameter requestParameters.timerId was null or undefined when calling showTimerApiControllerRemoveLiveStreamTimer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}/timers/{timerId}`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))).replace(`{${"timerId"}}`, encodeURIComponent(String(requestParameters.timerId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async showTimerApiControllerRemoveLiveStreamTimer(requestParameters: ShowTimerApiControllerRemoveLiveStreamTimerRequest): Promise<void> {
        await this.showTimerApiControllerRemoveLiveStreamTimerRaw(requestParameters);
    }

    /**
     */
    async showTimerApiControllerRemoveUpcomingShowTimerRaw(requestParameters: ShowTimerApiControllerRemoveUpcomingShowTimerRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.upcomingShowId === null || requestParameters.upcomingShowId === undefined) {
            throw new runtime.RequiredError('upcomingShowId','Required parameter requestParameters.upcomingShowId was null or undefined when calling showTimerApiControllerRemoveUpcomingShowTimer.');
        }

        if (requestParameters.timerId === null || requestParameters.timerId === undefined) {
            throw new runtime.RequiredError('timerId','Required parameter requestParameters.timerId was null or undefined when calling showTimerApiControllerRemoveUpcomingShowTimer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/upcoming-shows/{upcomingShowId}/timers/{timerId}`.replace(`{${"upcomingShowId"}}`, encodeURIComponent(String(requestParameters.upcomingShowId))).replace(`{${"timerId"}}`, encodeURIComponent(String(requestParameters.timerId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async showTimerApiControllerRemoveUpcomingShowTimer(requestParameters: ShowTimerApiControllerRemoveUpcomingShowTimerRequest): Promise<void> {
        await this.showTimerApiControllerRemoveUpcomingShowTimerRaw(requestParameters);
    }

}
